var ProductArchive = Barba.BaseView.extend({
    namespace: 'product-archive',
    onEnter: function() {
        // The new Container is ready and attached to the DOM.
        $('select').selectric();
        animateHeroBackground ();
    },
    onEnterCompleted: function() {
        // The Transition has just finished.
        // $('.selectric-hide-select option').click(function(e){
        //     console.log('sup');
        //     e.preventDefault();
        //     e.stopPropagation();
        // })


    },
    onLeave: function() {
        // A new Transition toward a new page has just started.
        $('html, body').animate({
            scrollTop: $('.catalog-container').offset().top
        }, 10);



    },
    onLeaveCompleted: function() {
        // The Container has just been removed from the DOM.
    }
});

// !!!! Don't forget to init the view in page-transitions/barba-init.js !!!!!


